import { render, staticRenderFns } from "./CHN.vue?vue&type=template&id=08996666&scoped=true"
import script from "./CHN.vue?vue&type=script&lang=js"
export * from "./CHN.vue?vue&type=script&lang=js"
import style0 from "./CHN.vue?vue&type=style&index=0&id=08996666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08996666",
  null
  
)

export default component.exports